import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Td, Tr } from './ui/Table';
import { StatusBadge } from './StatusBadge';
import { formatDate, formatDuration } from '../lib/format';

interface Run {
  id: number;
  taskName?: string;
  startedAt: string;
  finishedAt?: string;
  status: string;
  durationMs?: number;
  stdout?: string;
  stderr?: string;
}

interface RunRowProps {
  run: Run;
  showTask?: boolean;
}

export function RunRow({ run, showTask }: RunRowProps) {
  const [expanded, setExpanded] = useState(false);

  const hasOutput = run.stdout || run.stderr;

  return (
    <>
      <Tr onClick={() => hasOutput && setExpanded(!expanded)}>
        {showTask && <Td className="font-medium">{run.taskName || '—'}</Td>}
        <Td className="text-tg-text-secondary text-xs">{formatDate(run.startedAt)}</Td>
        <Td className="text-tg-text-secondary text-xs">
          {run.durationMs != null ? formatDuration(run.durationMs) : '—'}
        </Td>
        <Td><StatusBadge status={run.status} /></Td>
        <Td>
          {hasOutput && (
            expanded ? <ChevronDown size={14} className="text-tg-text-secondary" /> : <ChevronRight size={14} className="text-tg-text-secondary" />
          )}
        </Td>
      </Tr>
      {expanded && hasOutput && (
        <Tr>
          <Td colSpan={showTask ? 5 : 4} className="p-0">
            <div className="p-3 space-y-2">
              {run.stdout && (
                <div>
                  <div className="text-xs text-tg-text-secondary mb-1">stdout</div>
                  <pre
                    className="text-xs rounded p-2 overflow-x-auto max-h-48 overflow-y-auto text-tg-text"
                    style={{ background: 'var(--tg-bg)' }}
                  >
                    {run.stdout.slice(0, 65536)}
                  </pre>
                </div>
              )}
              {run.stderr && (
                <div>
                  <div className="text-xs text-tg-text-secondary mb-1">stderr</div>
                  <pre
                    className="text-xs rounded p-2 overflow-x-auto max-h-48 overflow-y-auto"
                    style={{ background: 'var(--tg-bg)', color: 'var(--tg-error)' }}
                  >
                    {run.stderr.slice(0, 65536)}
                  </pre>
                </div>
              )}
            </div>
          </Td>
        </Tr>
      )}
    </>
  );
}
